// extracted by mini-css-extract-plugin
export default {"label":"param-block_label__1MvY5","value":"param-block_value__DiWGy"};